/**
 * Pure helpers over the core's legalMoves() output (no three.js / DOM —
 * node-testable). The UI never re-derives game rules; it only *filters*
 * the Move objects the core already generated.
 */

/** UI display names for ability ids (see docs/CORE_INTERFACE.md). */
export const ABILITY_LABELS = {
  wallJump: '壁越え',
  removeWall: '壁除去',
  diagonalStep: '斜め移動',
  dash: '直線ダッシュ',
  swap: '入れ替え',
  shove: '押し出し',
  hex: '呪縛',
  steal: '壁泥棒',
};

/** All ability moves in a legalMoves() result. */
export function abilityMovesOf(legal) {
  return legal.filter((m) => m.type === 'ability');
}

/**
 * Destination cells of cell-targeted ability moves (wallJump / diagonalStep).
 * `to` is already the final resting cell (ice slides applied by the core).
 */
export function abilityTargetCells(legal) {
  return abilityMovesOf(legal)
    .filter((m) => m.to)
    .map((m) => ({ col: m.to.col, row: m.to.row }));
}

/** Wall-targeted ability moves (removeWall): [{ at, orientation }]. */
export function abilityWallTargets(legal) {
  return abilityMovesOf(legal)
    .filter((m) => m.at)
    .map((m) => ({ at: { col: m.at.col, row: m.at.row }, orientation: m.orientation }));
}

/** True iff pass is the ONLY legal move (the stalemate-escape case). */
export function isPassOnly(legal) {
  return legal.length === 1 && legal[0].type === 'pass';
}
